import { FC, useContext } from 'react'

import { ImportOrdersContext } from '../ImportOrders.context'
import ThirdStepStandard from './ThirdStepStandard/ThirdStepStandard'
import ThirdStepVerticalHorizontal from './ThirdStepVerticalHorizontal/ThirdStepVerticalHorizontal'

const ThirdStep: FC = () => {
  const { fileType } = useContext(ImportOrdersContext)

  return (
    <>
      {fileType === 'standard' && <ThirdStepStandard />}
      {(fileType.includes('Vertical') || fileType.includes('Horizontal')) && (
        <ThirdStepVerticalHorizontal />
      )}
    </>
  )
}

export default ThirdStep
